(function ($, Drupal, once) {

  'use strict';

  Drupal.behaviors.weaver_carousels = {

    initHorizontalScrolling: function() {
      const carousels = document.querySelectorAll('.nvcl-horizontal-scrolling-carousel');

      if (carousels.length < 1) {
        return;
      }

      carousels.forEach((carousel) => {
        this.initHorizontalScrollingNav(carousel);
      });
    },

    initHorizontalScrollingNav: function(carousel) {
      const nav = carousel.parentNode.querySelector('.nvcl-horizontal-scrolling-nav');

      if (nav ==  null) {
        return;
      }

      const buttons = nav.querySelectorAll('button');

      if (buttons.length < 1) {
        return;
      }

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          this.scrollHorizontalCarousel(button, carousel);
        });
      });
    },

    scrollHorizontalCarousel: function(button, carousel) {
      if (button.dataset.nvclNav == undefined) {
        return;
      }

      const direction = button.dataset.nvclNav;

      if (direction == 'next') {
        carousel.scrollLeft += 500;
      } else {
        carousel.scrollLeft += -500;
      }
    },

    attach: function (context, settings) {          
      $(once('weaver_carousels', 'body', context)).each(function () {
  
          const weaver = Drupal.behaviors.weaver_carousels;

          weaver.initHorizontalScrolling();

          ///////////////////////////////////////
          // CAROUSELS
          //

          // Event 3 at a time
          const eventCarousels = document.querySelectorAll('.event-carousel');
          if (eventCarousels.length > 0) {

            $(".event-carousel").owlCarousel({
              //autoHeight: true,
              dots: false,
              loop: false,
              lazyLoad: true,
              margin: 32,
              nav: true,
              navText: [
                '<div class="nav-button owl-prev"><i class="fa-regular fa-2x fa-arrow-left fa-2x"></i></div>', 
                '<div class="nav-button owl-next"><i class="fa-regular fa-2x fa-arrow-right fa-2x"></i></div>'
              ],
              responsive: {
                0: {
                  items: 1
                },
                768: {
                  items: 2,
                  slideBy: 2
                },
                1200: {
                  items: 3,
                  slideBy: 3
                  // stagePadding: 100
                },
                1900: {
                  items: 4,
                  slideBy: 4
                }
              }
            });
          }

          // Current Events (Home page)
          const currentEventCarousels = document.querySelectorAll('.current-event-carousel');
          if (currentEventCarousels.length > 0) {

            $(".current-event-carousel").owlCarousel({
              //autoHeight: true,
              dots: false,
              loop: false,
              lazyLoad: true,
              margin: 32,
              nav: true,
              navText: [
                '<div class="nav-button owl-prev"><i class="fa-regular fa-2x fa-arrow-left fa-2x"></i></div>', 
                '<div class="nav-button owl-next"><i class="fa-regular fa-2x fa-arrow-right fa-2x"></i></div>'
              ],
              responsive: {
                0: {
                  items: 1,
                  loop: false
                },
                1200: {
                  items: 2,
                  slideBy: 2
                  // stagePadding: 100                
                },
                1600: {
                  items: 3,
                  slideBy: 3
                }
              }
            });
          }

          // Home Hero Event 1 at a time
          const homeHeroCarousels = document.querySelectorAll('.hero-event-carousel');
          if (homeHeroCarousels.length > 0) {

            $(".hero-event-carousel").owlCarousel({
              // autoHeight: true,
              dots: false,
              items: 1,
              loop: false,
              lazyLoad: true,
              margin: 0,
              nav: true,
              navText: [
                '<div class="nav-button owl-prev font-weight-black link-blue-darker">Prev</div>', 
                '<div class="nav-button owl-next font-weight-black link-blue-darker">Next</div>'
              ],
              // stagePadding: 0,
              responsive: {
                0: {
                  autoWidth: false
                },
                1600: {
                  autoWidth: true
                }
              }
            });
          }

          // Showcases
          const showcaseCarousels = document.querySelectorAll('.showcase-carousel');
          if (showcaseCarousels.length > 0) {
            $(".showcase-carousel").owlCarousel({
              dots: false,
              loop: false,
              lazyLoad: true,
              lazyLoadEager: 1,
              margin: 32,
              nav: true,
              navText: [
                '<div class="nav-button owl-prev"><i class="fa-regular fa-arrow-left fa-2x"></i></div>', 
                '<div class="nav-button owl-next"><i class="fa-regular fa-arrow-right fa-2x"></i></div>'
              ],
              responsive: {
                0: {
                  items: 1,
                },
                768: {
                  items: 3,
                  slideBy: 3,
                },
                1200: {
                  items: 5,
                  slideBy: 5
                }
              }
            });
          }
      });

    }
  };

})(jQuery, Drupal, once);
